<template lang="pug">
div.mb-2
  div(v-if="nextPickupRequestDate")
    div Siguiente fecha de retiro: {{$moment(nextPickupRequestDate.pickupDate).format('DD-MM-YYYY')}}
    div(v-if="!editMode" style="display: flex; align-items: center; max-width: 100%;")
      div Fecha de cierre de retiros: {{$moment(nextPickupRequestDate.pickupClosingTime).format('DD-MM-YYYY HH:mm')}}
      b-button.ml-2.boton-editar(@click="showForm")
        .material-icons edit
    div(v-else)
      b-form(@submit.stop.prevent="onSubmit")
        b-form-group(
          label="Hora de cierre de retiros"
          description="Si la hora es mayor a 10:00 AM se asume que es para el día anterior"
          invalid-feedback="Este campo es requerido"
        )
          b-form-input(type="time" v-model="form.pickupClosingTime" :state="$v.form.pickupClosingTime.$error ? false : null")
        div.mt-2(style="display: flex; gap: 8px; width: 100%;")
          b-button(@click="onSubmit" size="sm") Guardar
          b-button(@click="onCancel" variant="outline-danger" size="sm") Cancelar
</template>

<script>
import roles from '../../common/roles'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import MakeToastMixin from '../mixins/MakeToastMixin'
import formatterUtils from '../../utils/formatterUtils'

export default {
  mixins: [MakeToastMixin],
  data () {
    return {
      formatterUtils,
      editMode: false,
      nextPickupRequestDate: null,
      pickupClosingTime: null,
      form: {
        pickupClosingTime: this.pickupClosingTime
      },
      roles: roles
    }
  },
  validations () {
    const form = {
      pickupClosingTime: { required }
    }
    return { form }
  },
  methods: {
    ...mapActions(['getBusinessSettings', 'updatePickupClosingTime', 'getNextPickupRequestDate']),
    onSubmit () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        this.makeDangerToast('Por favor, completa todos los campos')
      } else {
        this.onUpdateUser()
      }
    },
    resetForm () {
      this.form = {
        pickupClosingTime: this.pickupClosingTime
      }
    },
    async fetchBusinessSettings () {
      const response = await this.getBusinessSettings()
      this.pickupClosingTime = response.data.pickupClosingTime
    },
    async fetchNextPickupRequestDate () {
      const response = await this.getNextPickupRequestDate()
      this.nextPickupRequestDate = response.data
      this.$forceUpdate()
    },
    showForm () {
      this.editMode = true
      this.resetForm()
    },
    onCancel () {
      this.editMode = false
      this.resetForm()
    },
    hideForm () {
      this.editMode = false
      this.resetForm()
    },
    async onUpdateUser () {
      try {
        const data = { ...this.form }
        const response = await this.updatePickupClosingTime({ data })
        this.pickupClosingTime = response.data.pickupClosingTime
        this.fetchNextPickupRequestDate()
        this.makeSuccessToast('El horario de cierre de retiros se editó correctamente')
        this.$emit('done')
        this.hideForm()
      } catch (error) {
        this.makeDangerToast(error.response.data.message || 'Error al editar el horario de cierre de retiros')
      }
    }
  },
  created () {
    this.fetchBusinessSettings()
    this.fetchNextPickupRequestDate()
  }
}
</script>
